<template>
	<div>
		<div class="mb-6 flex items-center justify-between">
      <h2 class="font-semibold text-lg text-black">Comentarios</h2>
      <button
        v-if="(!showForm) && (props.comments == null || props.comments.comment == '')"
        @click="showForm = true"
        class="group text-tuin-100 border border-tuin-100 hover:bg-tuin-100 hover:text-white flex items-center justify-center gap-2 sm:px-4 sm:py-2.5 p-2.5 sm:rounded-lg rounded-full transition text-sm font-medium"
      >
        <svg class="only-dest" xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C4.21217 0 4.41566 0.0842856 4.56569 0.234315C4.71571 0.384344 4.8 0.587827 4.8 0.8V3.2H7.2C7.41217 3.2 7.61566 3.28429 7.76569 3.43431C7.91571 3.58434 8 3.78783 8 4C8 4.21217 7.91571 4.41566 7.76569 4.56569C7.61566 4.71571 7.41217 4.8 7.2 4.8H4.8V7.2C4.8 7.41217 4.71571 7.61566 4.56569 7.76569C4.41566 7.91571 4.21217 8 4 8C3.78783 8 3.58434 7.91571 3.43431 7.76569C3.28429 7.61566 3.2 7.41217 3.2 7.2V4.8H0.8C0.587827 4.8 0.384344 4.71571 0.234315 4.56569C0.0842856 4.41566 0 4.21217 0 4C0 3.78783 0.0842856 3.58434 0.234315 3.43431C0.384344 3.28429 0.587827 3.2 0.8 3.2H3.2V0.8C3.2 0.587827 3.28429 0.384344 3.43431 0.234315C3.58434 0.0842856 3.78783 0 4 0V0Z" class="fill-tuin-100 group-hover:fill-white"/>
        </svg>
        <svg class="only-mob fill-tuin-100 stroke-tuin-100 group-hover:fill-white group-hover:stroke-white transition" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 8H1H8Z"/>
          <path d="M8 1V8M8 8V15M8 8H15M8 8H1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="only-dest">Agregar Comentarios</span>
      </button>
    </div>

    <div
      v-if="(props.comments != null && props.comments.comment != '') || showForm"
      class="bg-gray-100 p-4 rounded-lg"
    >
      <textarea
        id="property_description"
        v-model="comment"
        rows="6"
        placeholder="Ingresa un comentario"
        class="block p-2.5 w-full text-base text-custom_gray rounded-lg border transition-colors"
        :class="errors.note ? 'bg-red-50 border border-red-500 focus:ring-tuin-100 focus:border-tuin-100' : 'bg-white border border-gray-300 focus:ring-tuin-100 focus:border-tuin-100'"
      >
      </textarea>
      <p v-if="errors.note" class="text-sm font-medium text-red-600 mt-1">{{ errors.note }}</p>

      <div class="flex items-end justify-end mt-3">
        <button
          class="w-full font-medium sm:w-auto px-5 py-2.5 bg-tuin-100 text-white rounded-lg text-sm hover:bg-tuin_hover disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          @click="save"
          :disabled="isLoading"
        >
          {{ isLoading ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </div>

		<div 
      class="flex flex-col items-center justify-center text-center py-8"
      v-else
    >
      <div class="flex justify-center items-center mb-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
					<path d="M31.6668 26.6667H27.4585C27.21 26.6669 26.9648 26.7232 26.7412 26.8314C26.5175 26.9396 26.3212 27.097 26.1668 27.2917L21.2918 33.375C21.1357 33.5703 20.9376 33.7279 20.7123 33.8362C20.487 33.9445 20.2402 34.0008 19.9902 34.0008C19.7402 34.0008 19.4933 33.9445 19.268 33.8362C19.0427 33.7279 18.8446 33.5703 18.6885 33.375L13.8135 27.2917C13.659 27.0967 13.4624 26.9393 13.2384 26.831C13.0144 26.7228 12.7689 26.6666 12.5202 26.6667H8.3335C5.5635 26.6667 3.3335 24.4367 3.3335 21.6667V10C3.3335 7.23 5.5635 5 8.3335 5H31.6668C34.4385 5 36.6668 7.23 36.6668 10V21.6667C36.6668 24.4367 34.4385 26.6667 31.6668 26.6667Z" stroke="#737373" stroke-width="1.5" stroke-miterlimit="10" stroke-linejoin="round"/>
				</svg>
      </div>
      <p class=" text-base text-gray-900">
        A parecer no hay ningún comentario
      </p>
    </div>
		
	</div>
</template>
<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import axios from "axios";

const store = useStore();
const session = computed(() => store.getters.getUserSession);
const props = defineProps({
  comments: {
    type: Object,
    default: () => ({}),
  },
  leadId: {
    type: Number,
    required: true,
  },
});
const emit = defineEmits(['comment-saved']);

let comment = ref(props.comments?.comment || '');
let showForm = ref(false);
let isLoading = ref(false);
let errors = ref({});
let asesor_id = session.value.id;

async function save() {
  errors.value = {};
  
  if (!comment.value?.trim()) {
    errors.value.note = 'El comentario es requerido';
    return;
  }

  if (isLoading.value) return;
  isLoading.value = true;

  let form_post = {
    lead_id: props.leadId,
    comment: comment.value,
    broker_id: asesor_id,
  };

  try { 
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    let url_link, method;

    if (props.comments && props.comments.comment) {
      // Modo edición - usar PUT para update
      url_link = `${process.env.VUE_APP_API_BASE_URL}/broker/lead/comments/update/${props.leadId}`;
      method = 'put';
    } else {
      // Modo creación - usar POST para create
      url_link = `${process.env.VUE_APP_API_BASE_URL}/broker/lead/comments/create`;
      method = 'post';
    }

    const response = await axios[method](url_link, form_post, options);

    if (response.status == 200) {
      emit('comment-saved');
    }
  } catch (error) {
    console.error("Error al guardar el comentario:", error);
  } finally {
    isLoading.value = false;
  }
}

</script>